import React from 'react'
import Footer from '../Modules/Components/Footer'
import Cart from '../Modules/CartModule/Cart'
import Header from '../Modules/Components/Header'

const Mycart = () => {
  return (
    <div>
      <Header />
      <Cart></Cart>
      <Footer></Footer>
    </div>
  )
}

export default Mycart